import {
  MdOutlineAccountBalance,
  MdOutlineBolt,
  MdOutlineLocalFireDepartment,
  MdOutlinePhoneInTalk,
  MdOutlineWaterDrop,
} from 'react-icons/md'
import { MenuItem } from '../types'

const utilityBillsMenu: MenuItem[] = [
  {
    icon: MdOutlineBolt,
    name: 'Electricity',
    path: '/purchases?tab=utilities&utility=electricity',
    code: 'utility-bills',
  },
  {
    icon: MdOutlineWaterDrop,
    name: 'Water',
    path: '/purchases?tab=utilities&utility=water',
    code: 'utility-bills',
  },
  {
    icon: MdOutlineLocalFireDepartment,
    name: 'Gas',
    path: '/purchases?tab=utilities&utility=gas',
    code: 'utility-bills',
  },
  {
    icon: MdOutlinePhoneInTalk,
    name: 'Telecommunications',
    path: '/purchases?tab=utilities&utility=telecommunications',
    code: 'utility-bills',
  },
  {
    icon: MdOutlineAccountBalance,
    name: 'Mortgage/Credit',
    path: '/purchases?tab=utilities&utility=mortgage',
    code: 'utility-bills',
  },
]

export default utilityBillsMenu
